export class Address {
	constructor(delivery) {
		this.forename = delivery.forename;
		this.surname = delivery.surname;
		this.email = delivery.email;
	}
}
